import { createContext, FC, PropsWithChildren, useContext, useMemo } from 'react';

type PageTitleContext = {
  title?: string;
};

const PageTitleContext = createContext<PageTitleContext>({});

type PageTitleProviderProps = PropsWithChildren & {
  title?: string;
};

export const PageTitleProvider: FC<PageTitleProviderProps> = ({ title, children }) => {
  const value = useMemo(() => ({ title }), [title]);

  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>;
};

export const usePageTitle = () => {
  const context = useContext(PageTitleContext);
  return context.title;
};
